import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
const EASE = [0.23, 1, 0.32, 1] as const;
const azar = (min: number, max: number) => min + Math.random() * (max - min);

// Valor inicial: 2 o 3 al azar.
const inicial = () => Math.random() < 0.5 ? 2 : 3;

// Próximo valor ponderado: 2 y 3 son los más comunes, 1 es raro.
// Puede repetirse el mismo número, así no sigue un patrón lineal.
const siguiente = (n: number): number => {
  const r = Math.random();
  if (n === 1) return r < 0.85 ? 2 : 1;
  if (r < 0.1) return 1;
  if (r < 0.55) return 2;
  return 3;
};

// Tiempo hasta el próximo cambio: a veces un salto rápido (~2s), casi siempre una pausa larga.
const proximaEspera = () => Math.random() < 0.25 ? azar(1800, 3000) : azar(8000, 18000);
export function LiveBuyersBar() {
  const [personas, setPersonas] = useState(inicial);
  const [tick, setTick] = useState(0);
  const reducir = useReducedMotion();
  useEffect(() => {
    // El primer cambio siempre llega rápido, a los ~2s de cargar la página.
    const espera = tick === 0 ? azar(1800, 2600) : proximaEspera();
    const t = window.setTimeout(() => {
      // Primer cambio: alterna entre 2 y 3. El 1 recién puede aparecer pasados unos segundos.
      setPersonas(n => {
        if (tick === 0) return n === 2 ? 3 : 2;
        const s = siguiente(n);
        return tick < 2 && s === 1 ? 2 : s;
      });
      setTick(x => x + 1);
    }, espera);
    return () => window.clearTimeout(t);
  }, [tick]);
  return <div aria-live="polite" className="w-full border-b border-white/10 bg-black px-4 py-3 text-white" data-id="element-131" data-mp="2jrb3cjf4diim">
      <p className="mx-auto flex max-w-6xl items-center justify-center gap-2.5 text-sm font-medium sm:text-base" data-id="element-132" data-mp="2ygh0m1uecynv">
        <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true" data-id="element-133" data-mp="2tlur647vlg6f">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-60 motion-reduce:hidden" data-id="element-134" data-mp="25w0bzg033fj0" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" data-id="element-135" data-mp="4w3wfvr3trzx" />
        </span>
        <span aria-hidden="true" data-id="element-136" data-mp="9uf2dvea3icv">👥</span>
        <AnimatePresence mode="wait" initial={false} data-id="element-137" data-mp="9tdshu9011wq">
          <motion.span key={personas} initial={{
          opacity: 0,
          y: reducir ? 0 : 4
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: reducir ? 0 : -4
        }} transition={{
          duration: 0.16,
          ease: EASE
        }} data-id="element-138" data-mp="el5859qm9n83">
            {personas === 1 ? '1 persona está comprando ahora mismo' : `${personas} personas están comprando ahora mismo`}
          </motion.span>
        </AnimatePresence>
      </p>
    </div>;
}